import CS3 from "../Components/ContentSection3";
import Footer from "../Components/Footer";
import Navbar from "../Components/NavBar";
import Team from "../Components/Team";
import ReservationWidget from '../Components/ReservationWidget';
export default function About() {
    return (
        <>
            <Navbar />
            <iframe
                src="https://widget.dinesurf.com/reserve.html?data-key=2355&data-actions=cancel,modify"
                width="100%"
                height="600"
                style={{ border: "none" }}
            ></iframe>
            <CS3 />
            <Team />
            {/* <Header title="Services" subtitle="We offer a wide range of services to help you get back on your feet." /> */}
            <Footer />
        </>
    )
}